import React from 'react';

const sizeMap = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-xl',
};

const Avatar = ({ initials = '?', size = 'md', className = '', ring = false }) => (
  <div
    className={`
      ${sizeMap[size]}
      rounded-full flex items-center justify-center
      font-syne font-bold text-white flex-shrink-0
      bg-gradient-to-br from-brand-600 to-brand-400
      ${ring ? 'ring-2 ring-brand-500 ring-offset-2 ring-offset-surface-800' : ''}
      ${className}
    `}
  >
    {initials}
  </div>
);

export default Avatar;
